class GoogleMaps {
  constructor() {
    "ngInject";
    this.googleMapsAPIKey = process.env.GOOGLE_MAPS_API_KEY;
  }

  getSource() {
    const src = `//maps.googleapis.com/maps/api/js?libraries=visualization,drawing,geometry,places&key=${this.googleMapsAPIKey}`;
    return src;
  }
}

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/services/googleMaps/googleMaps.service.js